export const TRACKING_EVENTS = {
  searchResults: {
    action: "DLP_SearchResults",
    category: "Search Name",
    label: "Domain results fetched",
  },
  cartApplied: {
    action: "DLP_Apply",
    category: "Add to Cart",
    label: "Domain added to cart",
  },
  otpGenerated: {
    action: "DLP_GetOTP",
    category: "OTP fetched",
    label: "OTP fetched successfully",
  },
  buyClicked: {
    action: "DLP_BuyNow",
    category: "Buy Now clicked",
    label: "Buy Now clicked",
  },
  domainPurchased: {
    action: "DLP_Purchased",
    category: "Domain purachased",
    label: "User purchased domain successfully",
  },
  domainCartSignInLaterClicked: {
    action: "DLP_Signin_later",
    category: "Sign In Later clicked",
    label: "User skips login",
  },
  postPurchaseManageDomainClicked: {
    action: "DLP_manage_DNS",
    category: "Post purchase manage DNS clicked",
    label: "Post Purchase Manege DNS",
  },
  postPurchaseGetWebsiteClicked: {
    action: "DLP_getWebsite",
    category: "Post purchase get website clicked",
    label: "Post Purchase Get Website",
  },
  searchOnEmptyCart: {
    action: "DLP_search_emptycart",
    category: "Search on empty cart",
    label: "Search on empty cart",
  },
  searchPerformed: {
    action: "DLP_search_searchresults",
    category: "Search performed",
    label: "Search performed",
  },
  searchContactUs: {
    action: "DLP_contactus_searchresults",
    category: "Contact us clicked on search page",
    label: "Contact us clicked on search page",
  },
  cartContactUs: {
    action: "DLP_contactus_cart",
    category: "Contact us clicked on cart page",
    label: "Contact us clicked on cart page",
  },
  searchOncartPage: {
    action: "DLP_search_cart",
    category: "search performed on cart page",
    label: "search performed on cart page",
  },
  domainTenureChange: {
    action: "DLP_domaintenure_cart",
    category: "domain tenure changed",
    label: "domain tenure changed",
  },
  domainRemoved: {
    action: "DLP_removedomain_cart",
    category: "domain removed",
    label: "domain removed",
  },
  postPurchaseContactUs: {
    action: "DLP_contactus_postpurhase",
    category: "post purchase contact us clicked",
    label: "post purchase contact us clicked",
  },
  domainSignInHeader: {
    action: "DLP_signin_header",
    category: "DLP sign in header clicked",
    label: "DLP sign in header clicked",
  },
  domainCartHeader: {
    action: "DLP_cart_header",
    category: "DLP header cart clicked",
    label: "DLP header cart clicked",
  },
  manageDomainHeader: {
    action: "DLP_managedomain_header",
    category: "DLP manage domain header clicked",
    label: "DLP manage domain header clicked",
  },
  manageWebsiteHeader: {
    action: "DLP_managewebsite_header",
    category: "DLP manage website header clicked",
    label: "DLP manage website header clicked",
  },
  logoutHeader: {
    action: "DLP_logout_header",
    category: "DLP logout header clicked",
    label: "DLP logout header clicked",
  },
  otpCartPage: {
    action: "DLP_GetOTP_cartPage",
    category: "OTP fetched on cart page",
    label: "Cart page OTP fetched successfully",
  },
  otpSearchResultPage: {
    action: "DLP_GetOTP_searchresult",
    category: "OTP fetched on search result page",
    label: "Search page OTP fetched successfully",
  },
  signInAndPayCartpage: {
    action: "DLP_signinandpay_cartpage",
    category: "sign in and pay cart page",
    label: "sign in and pay cart page",
  },
  otpVerified: {
    action: "DLP_OTPVerified",
    category: "OTP verified",
    label: "OTP verified on add to cart click successfully",
  },
  otpVerifiedHeader: {
    action: "DLP_OTPVerified_Header",
    category: "OTP verified",
    label: "OTP verified from sign in from header successfully",
  },
  otpVerifiedSignIn: {
    action: "DLP_OTPVerified_Signin",
    category: "OTP verified",
    label: "OTP verified from sign and click successfully",
  },
  postPurchaseGoToDashboard: {
    action: "DLP_postpurchase_gotodashboard",
    category: "post purchase go to dashboard clicked",
    label: "post purchase go to dashboard clicked",
  },
  postPurchaseRequestToCallback: {
    action: "DLP_RequestCallback_underReviews",
    category: "post purchase request to callback",
    label: "post purchase request to callback",
  },
  postPurchaseThemeUpsellPopupRTC: {
    action: "DLP_RAC_30MinUpsellPopup",
    category: "post purchase request to callback 30 min upsell",
    label: "post purchase request to callback 30 min upsell",
  },
  postPurchaseThemeUpsellExploreWebsite: {
    action: "DLP_ExploreWebsite_30MinUpsellPopup",
    category: "post purchase request to callback 30 min upsell",
    label: "post purchase request to callback 30 min upsell",
  },
};
